export default "__VITE_ASSET__a0e4b7b9__"